module.exports = __webpack_public_path__ + "img/waterlilly2.1c8fd207.jpg";